import {
    Stack,
    Tabs,
    Divider,
    Tab,
    TabProps,
    styled,
    Box
} from "@mui/material";
import TabPanel from "components/tabPanel";
import { useEncounter } from "../encounter.provider";
import SimpleBar from "simplebar-react";
import FavoriteDiagnosis from "./favoriteDiagnosis";
import ReDiagnosis from "./reDiagnosis";

const StyledTab = styled(({ ...props }: TabProps) => <Tab {...props} />)(
    ({ theme }) => ({
        "&.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4
        }
    })
);

const UtilityBox = () => {
    const { onChangeUtilTab, activeUtilTab } = useEncounter();

    return (
        <Stack width="100%" spacing={1}>
            <Tabs
                value={activeUtilTab}
                onChange={onChangeUtilTab}
                textColor="primary"
                variant="fullWidth"
                indicatorColor="primary"
            >
                <StyledTab value="fav-dx" label="FAVORITE DX" />
                <StyledTab value="re-dx" label="Re-DX" />
            </Tabs>

            <Divider />

            <Box
                component={SimpleBar}
                sx={{ height: "calc(100vh - 300px)", overflow: "auto" }}
            >
                <TabPanel value={activeUtilTab} index="fav-dx">
                    <FavoriteDiagnosis />
                </TabPanel>
                <TabPanel value={activeUtilTab} index="re-dx">
                    <ReDiagnosis />
                </TabPanel>
            </Box>
        </Stack>
    );
};

export default UtilityBox;
